import { Layout as AntLayout } from 'antd';
import Loader from 'react-top-loading-bar';
import styled, { css } from 'styled-components';
import { Page } from '../../molecules/page';

export const Progress = styled(Loader).attrs({
  color: 'var(--blue-60)',
})`
  position: absolute !important;
  z-index: var(--zindex-layer-02) !important;
`;

export const StyledPage = styled(Page)`
  ${Page.Header} {
    position: sticky;
    top: 0;
    z-index: 10;
    background: var(--white-100);
  }
  ${Page.Content} {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
//height: calc(100vh - ${2 * $outlineWidth}px);
export const AuxiliaryPanel = styled.div<{ $outlineWidth?: number }>`
  background-color: var(--white-100);
  border-left: 1px solid var(--field-border-default);
  height: 100%;
  ${({ $outlineWidth = 0 }) =>
    $outlineWidth !== 0
      ? css`
          margin: ${$outlineWidth}px;
          border-radius: var(--border-radius-default);
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        `
      : ''};
`;
export const PageWrapper = styled.div<{
  $hasAuxiliaryPanel?: boolean;
  $outlineWidth?: number;
}>`
  display: flex;
  height: 100%;
  overflow: hidden;
  background-color: var(--white-100);
  border-radius: var(--border-radius-small);
  ${({ $hasAuxiliaryPanel = false }) =>
    $hasAuxiliaryPanel
      ? css`
          ${StyledPage} {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        `
      : ''};
  ${({ $outlineWidth = 0 }) =>
    $outlineWidth !== 0
      ? css`
          margin: ${$outlineWidth}px;
          height: calc(100% - ${2 * $outlineWidth}px);
          margin-left: 0px;
        `
      : ''};
`;

export const Layout = styled(AntLayout)`
  align-items: stretch;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  div[data-resizing='true'] .ant-layout-sider {
    transition: all 0s;
  }
  /* enable transition when closing and opening sidebar */
  .resizable-wrapper {
    transition: all 0.3s cubic-bezier(0.29, 0.04, 0.23, 1);
  }
`;

export const Sider = styled(Layout.Sider)`
  flex: 0 0 256px;
  max-width: 256px;
  min-width: 256px;
  width: 256px;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background: var(--white-100);
`;
export const Content = styled(Layout.Content)`
  align-items: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div<{
  $full?: boolean;
  $gray?: boolean;
}>`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  ${({ $gray = false }) =>
    $gray
      ? css`
          background-color: var(--scarlet-background-tertiary);
        `
      : ''};
`;
